import * as Yup from "yup";
import { ActionTypes } from "./BasicInfoFields";
import {
  enableContentType,
  enableCourse,
  enableMinimumScore,
  enableJournalPrompt,
  journalPromptBriefMaxLength,
} from "./ProprietarySpecificFields";

const basicInfoSchema = () =>
  Yup.object().shape({
    actionItemType: Yup.string().required(),
    proprietarySpecificActionType: Yup.string()
      .nullable()
      .when("actionItemType", {
        is: (value) => value === ActionTypes.ProprietarySpecific,
        then: Yup.string().required(),
        otherwise: Yup.string().nullable().optional(),
      }),
    proprietarySpecificContent: Yup.string()
      .nullable()
      .when(["actionItemType", "proprietarySpecificActionType"], {
        is: (actionItemType, proprietarySpecificActionType) =>
          actionItemType === ActionTypes.ProprietarySpecific &&
          enableContentType.includes(Number(proprietarySpecificActionType)),
        then: Yup.string().required(),
        otherwise: Yup.string().nullable().optional(),
      }),
    proprietarySpecificCourse: Yup.string()
      .nullable()
      .when(["actionItemType", "proprietarySpecificActionType"], {
        is: (actionItemType, proprietarySpecificActionType) =>
          actionItemType === ActionTypes.ProprietarySpecific &&
          enableCourse.includes(proprietarySpecificActionType),
        then: Yup.string().required(),
        otherwise: Yup.string().nullable().optional(),
      }),
    proprietarySpecificJournalPrompt: Yup.number()
      .nullable()
      .when(["actionItemType", "proprietarySpecificActionType"], {
        is: (actionItemType, proprietarySpecificActionType) =>
          actionItemType === ActionTypes.ProprietarySpecific &&
          enableJournalPrompt.includes(Number(proprietarySpecificActionType)),
        then: Yup.number().required("A journal prompt is required"),
        otherwise: Yup.number().nullable().optional(),
      }),
    journalPromptBrief: Yup.string()
      .nullable()
      .when(["actionItemType", "proprietarySpecificActionType"], {
        is: (actionItemType, proprietarySpecificActionType) =>
          actionItemType === ActionTypes.ProprietarySpecific &&
          enableJournalPrompt.includes(Number(proprietarySpecificActionType)),
        then: Yup.string()
          .trim()
          .max(
            journalPromptBriefMaxLength,
            `Can only be ${journalPromptBriefMaxLength} characters`
          )
          .required("A brief prompt is required"),
        otherwise: Yup.string().nullable().optional(),
      }),
    proprietaryGeneralActionType: Yup.string()
      .nullable()
      .when(["actionItemType"], {
        is: (actionItemType) =>
          actionItemType === ActionTypes.ProprietaryGeneral,
        then: Yup.string().required(),
        otherwise: Yup.string().nullable().optional(),
      }),    proprietaryGeneralAmount: Yup.number()
      .nullable()
      .when(["actionItemType"], {
        is: (actionItemType) =>
          actionItemType === ActionTypes.ProprietaryGeneral,
        then: Yup.number().min(1, "Must be at least one").required(),
        otherwise: Yup.number().nullable().optional(),
      }),
    thirdPartyActionTitle: Yup.string()
      .nullable()
      .when("actionItemType", {
        is: (value) => value === "Third Party",
        then: Yup.string().max(75, "Can only be 75 characters").required(),
        otherwise: Yup.string().nullable().optional(),
      }),
    thirdPartyCompletionMechanism: Yup.string()
      .nullable()
      .when("actionItemType", {
        is: (value) => value === "Third Party",
        then: Yup.string().required(),
        otherwise: Yup.string().nullable().optional(),
      }),
      thirdPartyHowItWorks: Yup.string()
      .nullable()
      .when("actionItemType", {
        is: (value) => value === "Third Party",
        then: Yup.string().required(),
        otherwise: Yup.string().nullable().optional(),
      }),
    questionActionTitle: Yup.string()
      .nullable()
      .when("actionItemType", {
        is: (value) => value === ActionTypes.OpenTextQuestion,
        then: Yup.string().max(75, "Can only be 75 characters").required(),
        otherwise: Yup.string().nullable().optional(),
      }),
    questionText: Yup.string()
      .nullable()
      .when("actionItemType", {
        is: (value) => value === ActionTypes.OpenTextQuestion,
        then: Yup.string().required(),
        otherwise: Yup.string().nullable().optional(),
      }),
    forceMinimumScore: Yup.boolean().nullable(),
    minimumScore: Yup.number()
      .nullable()
      .when("forceMinimumScore", {
        is: true,
        then: Yup.number()
          .min(0, "Score must be between 0 and 100")
          .max(100, "Score must be between 0 and 100")
          .required("Minimum score is required"),
        otherwise: Yup.number().nullable().optional(),
      }),
  });
export default basicInfoSchema;
